export default "__VITE_ASSET__c716c091__"